import { _get, _post, _put } from "../../../../apiClient";
import config from "../../../../config";
import { _showToast } from "../../../../toastHelper";
import moment from 'moment';
import { uploadImage, deleteImages } from "../../../Services/ImageService";
let invitationJson;
let lastEventDate;
let deletedKeys = [];
let imageCount = 0;
let videoCount = 0;

export default async function Save(sections, themeId, categoryId, eventId, eventCode, deletedImages, titles) {
    invitationJson = {};
    deletedKeys = [...deletedImages]
    imageCount = 0;
    videoCount = 0;
    invitationJson.version = "1.0";
    invitationJson.studioId = "";
    if (sections && sections.length > 0) {
        let isValid = true;
        sections.forEach(section => {
            if (!section.isValid)
                isValid = false;
        });

        if (isValid) {
            if (!eventCode || (eventCode && eventCode == ""))
                eventCode = await getEventCode();

            if (eventCode && eventCode != "") {

                if (await checkImageAndVideoStatus(sections, eventCode)) {

                    for (const section of sections) {
                        if (section.sectionname == "invitation") {
                            if (!await processingInvitationDetails(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "couple") {
                            if (!await processCoupleDetails(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "events") {
                            if (!await processingEvents(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "gallery") {
                            if (!await processingGallery(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "people") {
                            if (!await processingPeople(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "story") {
                            if (!await processingStory(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "studio") {
                            invitationJson.studioId = section.data;
                        }
                        else if (section.sectionname == "theme") {
                            if (!await processingSliders(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                    }
                    processingCustomization(titles);
                    if (!eventId || (eventId && eventId == 0))
                        return await createEvent(eventCode, themeId, categoryId);
                    else
                        return await updateEvent(eventId, eventCode);
                }
                else {
                    return {
                        status: "failed",
                        message: ""
                    };
                }
            }

            return {
                status: "failed",
                message: "Unable to process your request"
            };
        }
        return {
            status: "failed",
            message: "Please provide data for all the required fields before saving"
        };
    }
}

const createEvent = async (eventCode, themeId, categoryId) => {

    if (invitationJson) {
        let postdata = {
            eventCode: eventCode,
            themeId: themeId,
            categoryId: categoryId,
            eventTitle: invitationJson.invitation.title,
            eventDate: moment(invitationJson.invitation.eventDate, 'YYYY-MM-DD').format("YYYYMMDD"),
            thumbnail: invitationJson.invitation.imageKey,
            expiration: invitationJson.invitation.expiration,
            studioId: invitationJson.studioId,
            jsonData: JSON.stringify(invitationJson),
            lastEventDate: moment(lastEventDate).format("YYYYMMDD"),
            imageCount: imageCount,
            videoCount: videoCount
        }

        return await _post("/events", postdata)
            .then(async (response) => {
                await deleteImages(deletedKeys);
                deletedKeys = [];


                return {
                    status: "success",
                    eventCode: postdata.eventCode,
                    eventId: response.id,
                    eventUrl: response.url,
                    message: "Event created successfully"
                };
            })
            .catch((error) => {
                return {
                    status: "failed",
                    message: error
                };
            });
    }
}

const updateEvent = async (eventId, eventCode) => {
    if (invitationJson) {
        let postdata = {
            id: eventId,
            eventTitle: invitationJson.invitation.title,
            eventDate: moment(invitationJson.invitation.eventDate, 'YYYY-MM-DD').format("YYYYMMDD"),
            thumbnail: invitationJson.invitation.imageKey,
            expiration: invitationJson.invitation.expiration,
            studioId: invitationJson.studioId,
            jsonData: JSON.stringify(invitationJson),
            lastEventDate: moment(lastEventDate).format("YYYYMMDD"),
            imageCount: imageCount,
            videoCount: videoCount
        }

        return await _put("/events", postdata)
            .then(async (response) => {
                await deleteImages(deletedKeys);
                deletedKeys = [];
                return {
                    status: "success",
                    eventCode: eventCode,
                    eventId: response.id,
                    eventUrl: response.url,
                    message: "Event updated successfully"
                };
            })
            .catch((error) => {
                return {
                    status: "failed",
                    message: error
                };
            });
    }
}

const checkImageAndVideoStatus = async (sections, eventCode) => {
    getImageAndVideoCount(sections);
    if (imageCount > 0 || videoCount > 0) {
        return await _get(`/uploads/check-upload-status?eventCode=${eventCode}&imageCount=${imageCount}&videoCount=${videoCount}&studioProfileId=0`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                _showToast(error, "error");
                return false;
            });
    }
    else
        return true;
}

const getEventCode = async () => {
    return await _get("/events/code/8")
        .then((response) => {
            return response
        })
        .catch((error) => {
            _showToast(error, "error");
            return "";
        });
}

const getImageAndVideoCount = async (sections) => {
    sections.forEach((section) => {
        if (section.data && Array.isArray(section.data)) {
            section.data.forEach((data) => {
                if ((data.imageKey && data.imageKey != "") || (data.imageFile && data.imageFile != null)) {
                    imageCount = imageCount + 1;
                }

                if ((data.videoUrl && data.videoUrl != "")) {
                    videoCount = videoCount + 1;
                }
            })
        }
        else {
            if ((section.data.imageKey && section.data.imageKey != "") || (section.data.imageFile && section.data.imageFile != null)) {
                imageCount = imageCount + 1;
            }

            if ((section.data.videoUrl && section.data.videoUrl != "")) {
                videoCount = videoCount + 1;
            }
        }
    });
}

const processingInvitationDetails = async (section, eventCode) => {
    let path = "";
    if (section.data.imageFile) {
        path = await uploadImage(`invitation-data/${eventCode}`, section.data.imageFile, eventCode, "EventThumb");
        if (!path || (path && path == ""))
            return false;

        if (section.data.imageKey && section.data.imageKey != "") {
            deletedKeys.push(section.data.imageKey);
        }
        section.data.imageFile = null;
        section.data.image = config.imagesbaseurl + path;
        section.data.imageKey = path;
    }

    invitationJson.invitation = {
        title: section.data.title,
        eventDate: section.data.eventDate,
        imageKey: section.data.imageKey,
        expiration: section.data.expiration,
        liveUrl: section.data.liveUrl
    }
    return true;
}

const processCoupleDetails = async (section, eventCode) => {
    invitationJson.couple = [];
    let datas = [];
    for (const data of section.data) {
        if (data.imageFile) {
            let path = await uploadImage(`invitation-data/${eventCode}`, data.imageFile, eventCode, "Couple");
            if (!path || (path && path == ""))
                return false;

            if (data.imageKey && data.imageKey != "") {
                deletedKeys.push(data.imageKey);
            }
            data.image = config.imagesbaseurl + path;
            data.imageFile = null;
            data.imageKey = path;
        }

        invitationJson.couple.push({
            title: data.title,
            tagLine: data.tagLine,
            imageKey: data.imageKey,
        });

        datas.push(data);
    }

    section.data = datas;
    return true;
}

const processingEvents = async (section, eventCode) => {
    invitationJson.events = [];
    if (section.data) {
        for (const event of section.data) {
            let eventDate = moment(event.date, 'YYYY-MM-DD').toDate();

            if (!lastEventDate || (lastEventDate && eventDate > lastEventDate))
                lastEventDate = eventDate;

            invitationJson.events.push(event);
        }
    }
    else {
        lastEventDate = moment(invitationJson.invitation.eventDate, 'YYYY-MM-DD');
    }
    return true;
}

const processingGallery = async (section, eventCode) => {
    invitationJson.gallery = [];
    let datas = [];
    for (const galleryItem of section.data) {
        if (galleryItem.imageFile) {
            let path = await uploadImage(`invitation-data/${eventCode}/gallery`, galleryItem.imageFile, eventCode, "Gallery");
            if (!path || (path && path == ""))
                return false;

            if (galleryItem.imageKey && galleryItem.imageKey != "") {
                deletedKeys.push(galleryItem.imageKey);
            }
            galleryItem.image = config.imagesbaseurl + path;
            galleryItem.imageFile = null;
            galleryItem.imageKey = path;
        }

        invitationJson.gallery.push({
            fileId: galleryItem.fileId,
            name: galleryItem.name,
            imageKey: galleryItem.imageKey,
            type: galleryItem.type,
            videoUrl: galleryItem.videoUrl,
            videoImage: galleryItem.videoImage,
            isPrimaryVideo: galleryItem.isPrimaryVideo
        });
        datas.push(galleryItem);
    }

    section.data = datas;
    return true;
}

const processingPeople = async (section, eventCode) => {
    invitationJson.peoples = [];
    let datas = [];
    for (const people of section.data) {
        if (people.imageFile) {
            let path = await uploadImage(`invitation-data/${eventCode}/people`, people.imageFile, eventCode, "People");
            if (!path || (path && path == ""))
                return false;

            if (people.imageKey && people.imageKey != "") {
                deletedKeys.push(people.imageKey);
            }
            people.image = config.imagesbaseurl + path;
            people.imageFile = null;
            people.imageKey = path;
        }

        invitationJson.peoples.push({
            name: people.name,
            relationship: people.relationship,
            imageKey: people.imageKey
        });

        datas.push(people);
    }
    section.data = datas;
    return true;
}

const processingStory = async (section, eventCode) => {
    invitationJson.stories = [];
    let datas = [];
    for (const story of section.data) {
        if (story.imageFile) {
            let path = await uploadImage(`invitation-data/${eventCode}/story`, story.imageFile, eventCode, "Story");
            if (!path || (path && path == ""))
                return false;

            if (story.imageKey && story.imageKey != "") {
                deletedKeys.push(story.imageKey);
            }
            story.image = config.imagesbaseurl + path;
            story.imageFile = null;
            story.imageKey = path;
        }

        invitationJson.stories.push({
            title: story.title,
            date: story.date,
            description: story.description,
            imageKey: story.imageKey
        });

        datas.push(story);
    }
    section.data = datas;
    return true;
}

const processingSliders = async (section, eventCode) => {
    invitationJson.sliders = [];
    let datas = [];
    for (const slider of section.data) {
        if (slider.imageFile) {
            let path = await uploadImage(`invitation-data/${eventCode}/sliders`, slider.imageFile, eventCode, "Banners");
            if (!path || (path && path == ""))
                return false;

            if (slider.imageKey && slider.imageKey != "") {
                deletedKeys.push(slider.imageKey);
            }
            slider.image = config.imagesbaseurl + path;
            slider.imageFile = null;
            slider.imageKey = path;
        }
        invitationJson.sliders.push({
            imageKey: slider.imageKey
        });
        datas.push(slider);
    }
    section.data = datas;
    return true;
}



const processingCustomization = async (data) => {
    invitationJson.titles = [];
    for (const title of data) {
        invitationJson.titles.push({
            title: title.title,
            sectionTitle: title.sectionTitle,
            sectionSubTitle: title.sectionSubTitle,
            navbarTitle: title.navbarTitle
        });
    }
    return true;
}

